import { render, staticRenderFns } from "./AccountViewer.vue?vue&type=template&id=4ff779b2"
import script from "./AccountViewer.vue?vue&type=script&lang=js"
export * from "./AccountViewer.vue?vue&type=script&lang=js"
import style0 from "./AccountViewer.vue?vue&type=style&index=0&id=4ff779b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports